import React, { useState } from 'react';
import { Form, Input, Button, notification, Typography, Divider } from 'antd';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { MailOutlined, ArrowRightOutlined, CheckCircleOutlined } from '@ant-design/icons';
import api from '../api/axios';
import AuthLayout from '../layouts/AuthLayout';

const { Title, Text } = Typography;

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await api.post('/forgot-password', { email: values.email });
            setSubmitted(true);
        } catch (error) {
            notification.error({
                message: 'Request Failed',
                description: 'Something went wrong. Please try again.',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SEO
                title="Forgot Password"
                description="Reset your Oottan account password."
                canonical="/forgot-password"
                noindex={true}
            />
            <AuthLayout>
                <div style={{ width: '100%' }}>
                    <div style={{ textAlign: 'center', marginBottom: '36px' }}>
                        <div style={{ width: '60px', height: '60px', borderRadius: '16px', background: 'linear-gradient(135deg,#AD1457,#D81B60)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', boxShadow: '0 8px 24px rgba(173,20,87,0.3)' }}>
                            {submitted
                                ? <CheckCircleOutlined style={{ fontSize: '1.6rem', color: 'white' }} />
                                : <MailOutlined style={{ fontSize: '1.6rem', color: 'white' }} />
                            }
                        </div>
                        <Title level={2} style={{ color: '#1A1A2E', marginBottom: '6px', fontWeight: '800', fontSize: '1.8rem' }}>
                            {submitted ? 'Check Your Email' : 'Forgot Password?'}
                        </Title>
                        <Text style={{ color: '#64748B', fontSize: '0.95rem' }}>
                            {submitted
                                ? 'A reset link has been sent if an account with that email exists.'
                                : 'We\'ll send you a secure reset link'}
                        </Text>
                    </div>

                    {submitted ? (
                        <div>
                            <div style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: '12px', padding: '16px 20px', marginBottom: '24px', textAlign: 'center' }}>
                                <Text style={{ color: '#166534', fontSize: '0.9rem', lineHeight: '1.6' }}>
                                    Please check your inbox and spam folder. The link expires in <strong>1 hour</strong>.
                                </Text>
                            </div>
                            <Button block size="large" onClick={() => setSubmitted(false)} style={{ borderRadius: '10px', height: '50px', marginBottom: '16px' }}>
                                Try a different email
                            </Button>
                        </div>
                    ) : (
                        <Form name="forgot-password" onFinish={handleSubmit} layout="vertical" size="large">
                            <Form.Item name="email" rules={[{ required: true, message: 'Please enter your email' }, { type: 'email', message: 'Please enter a valid email' }]}>
                                <Input prefix={<MailOutlined style={{ color: '#AD1457' }} />} type="email" placeholder="Enter your email address" style={{ borderRadius: '10px', height: '50px' }} />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: '12px' }}>
                                <Button type="primary" htmlType="submit" block loading={loading} icon={<ArrowRightOutlined />} style={{ height: '50px', borderRadius: '10px', fontSize: '1rem', fontWeight: '700', background: 'linear-gradient(135deg,#AD1457,#D81B60)', border: 'none', boxShadow: '0 6px 20px rgba(173,20,87,0.35)' }}>
                                    Send Reset Link
                                </Button>
                            </Form.Item>
                        </Form>
                    )}

                    <Divider style={{ margin: '20px 0', borderColor: '#E2E8F0' }}>
                        <Text style={{ color: '#94A3B8', fontSize: '0.82rem' }}>OR</Text>
                    </Divider>

                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                        <Text style={{ color: '#64748B', fontSize: '0.9rem' }}>Remember your password?{' '}</Text>
                        <Link to="/login" style={{ color: '#AD1457', fontWeight: '700', fontSize: '0.9rem', textDecoration: 'none' }}>Sign In</Link>
                    </div>

                    <div style={{ textAlign: 'center', paddingTop: '16px', borderTop: '1px solid #F1F5F9' }}>
                        <Text style={{ color: '#94A3B8', fontSize: '0.78rem' }}>
                            {process.env.REACT_APP_RELEASE_DATE} · v{process.env.REACT_APP_RELEASE_VERSION}
                        </Text>
                    </div>
                </div>
            </AuthLayout>
        </>
    );
};

export default ForgotPassword;
